import RectLoader from "../../../loaders/Rectangle";
import "./profileTabsLoaderWeb.scss";
function ProfileTabsLoaderWeb() {
	return (
		<div id="profile-tabs-loader-web" className="flex-column">
			<div className="tabs mb-3 flex-row">
				<div className="single-loader-tab">
					<RectLoader height={19} radius={0} width={83} />
				</div>
				<div className="single-loader-tab">
					<RectLoader height={19} radius={0} width={83} />
				</div>
				<div className="single-loader-tab">
					<RectLoader height={19} radius={0} width={83} />
				</div>
			</div>
			<div className="tab-content">
				<div className="credential-grid">
					<div className="category-loader flex-row">
						<div className="category-img">
							<RectLoader height={70} radius={5} width={70} />
						</div>
						<span className="category-title">
							<RectLoader height={25} radius={0} width={140} />
						</span>
						<span className="credential-count">
							<RectLoader height={25} radius={0} width={140} />
						</span>
					</div>
					{[1, 2, 3].map((credential, index) => {
						return (
							<div
								key={`loader-${index}-1`}
								className="single-credential flex-column cursor-pointer"
							>
								<RectLoader height={30} radius={0} width={740} />
							</div>
						);
					})}
				</div>
				<div className="credential-grid">
					<div className="category-loader flex-row">
						<div className="category-img">
							<RectLoader height={70} radius={5} width={70} />
						</div>
						<span className="category-title">
							<RectLoader height={25} radius={0} width={140} />
						</span>
						<span className="credential-count">
							<RectLoader height={25} radius={0} width={140} />
						</span>
					</div>
					{[1, 2, 3].map((credential, index) => {
						return (
							<div
								key={`loader-${index}-2`}
								className="single-credential flex-column cursor-pointer"
							>
								<RectLoader height={30} radius={0} width={740} />
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
export default ProfileTabsLoaderWeb;
